import OrderListFilter from "@/models/order/OrderListFilter";

export default class OrderListFilterShop extends OrderListFilter {

}
